import __request__ from "routing/request";
export function getConditions(requestOptions) {
  return __request__("GET", "/streams/destinations/filters/builder/conditions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function simulateRule(requestOptions) {
  return __request__("POST", "/streams/destinations/filters/builder/simulate", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateRule(rule, requestOptions) {
  return __request__("POST", "/streams/destinations/filters/builder/validate", rule, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
